// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"BV","reco":"CV","products":"DV"};